import { render, staticRenderFns } from "./PublicHolidayNewEditDialog.vue?vue&type=template&id=09270c67&scoped=true"
import script from "./PublicHolidayNewEditDialog.vue?vue&type=script&lang=js"
export * from "./PublicHolidayNewEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayNewEditDialog.vue?vue&type=style&index=0&id=09270c67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09270c67",
  null
  
)

export default component.exports